module.exports = __webpack_public_path__ + "static/media/DooPeterElishNc.285ab27d.svg";